<template>
  <div v-loading="listLoading" element-loading-text="拼命加载中...">
    <!-- <div class="breadcrumb">
            <el-breadcrumb separator-class="el-icon-arrow-right" class="systemTag">
            </el-breadcrumb>
        </div> -->
    <div class="filter" style="margin-top:-30px">
      <el-tabs type="border-card" class="card-tab">
        <el-tab-pane label="筛选">
          <el-form :model="param" :inline="true" label-width="100px" class="formInline" size="mini">
            <div class="slide-wrap" ref="slideWrap1">
              <el-form-item label="任务名称">
                <el-input v-model="param.posName" placeholder="请输入任务名称..." :maxlength="30"></el-input>
              </el-form-item>
              <el-form-item label="项目编号">
                <el-input v-model="param.proCode" placeholder="请输入项目编号..." :maxlength="30"></el-input>
              </el-form-item>
              <el-form-item label="项目名称">
                <el-input v-model="param.proName" placeholder="请输入项目名称..." :maxlength="20"></el-input>
              </el-form-item>
              <el-form-item label="门店名称">
                <el-input v-model="param.storeName" placeholder="请输入门店名称..." :maxlength="15"></el-input>
              </el-form-item>
              <el-form-item label="门店编码">
                <el-input v-model="param.storeCode" placeholder="请输入门店编码..." :maxlength="25"></el-input>
              </el-form-item>
              <el-form-item label="发布人">
                <el-input v-model="param.postMan" placeholder="请输入发布人..." :maxlength="5"></el-input>
              </el-form-item>
              <el-form-item label="促销员姓名">
                <el-input v-model="param.salesmanName" placeholder="请输入促销员姓名..." :maxlength="6"></el-input>
              </el-form-item>
              <el-form-item label="促销员身份证">
                <el-input v-model="param.salesmanIdCard" placeholder="请输入促销员身份证号..." :maxlength="18"></el-input>
              </el-form-item>
              <el-form-item label="促销员ID">
                <el-input v-model="param.empPk" placeholder="请输入促销员ID..." :maxlength="12"></el-input>
              </el-form-item>
              <el-form-item label="所在地区">
                <el-select v-model="param.provinceId" filterable placeholder="请选择地区..." @change="searchCity">
                  <el-option label="不限" :value="null"></el-option>
                  <el-option :label="item.adName" :value="item.id" v-for="item in provinceList"
                             :key="item.id"></el-option>
                </el-select>
                <el-select v-model="param.cityId" filterable placeholder="请选择地区...">
                  <el-option label="不限" :value="null"></el-option>
                  <el-option :label="item.adName" :value="item.id" v-for="item in cityList" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="终端">
                <el-autocomplete
                    v-model="param.terminal"
                    :fetch-suggestions="querySearch"
                    placeholder="请输入终端..."
                ></el-autocomplete>

              </el-form-item>
              <el-form-item label="岗位状态">
                <el-select v-model="param.post" filterable placeholder="请选择...">
                  <el-option :label="item.name" :value="item.id" v-for="(item,index) in choosePost"
                             :key="index"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="应聘状态">
                <el-select v-model="param.apply" filterable placeholder="请选择...">
                  <el-option :label="item.name" :value="item.id" v-for="(item,index) in chooseApply"
                             :key="index"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="发布时间">
                <el-date-picker v-model="param.publishTimeStart" placeholder="请输入最小发布时间..." value-format="yyyy-MM-dd"></el-date-picker>
                <span>-</span>
                <el-date-picker v-model="param.publishTimeEnd" placeholder="请输入最大发布时间..." value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
              <el-form-item label="岗位编码">
                <el-input v-model="param.code" placeholder="请输入岗位编码..."></el-input>
              </el-form-item>
            </div>
            <hr style="margin-bottom: 9px;">
            <div class="slide-btns clearfix">
              <el-form-item>
                <el-button type="text" class="reset-btn" @click="resetForm()">清空</el-button>
                <el-button class="search-btn" @click="submitForm()">筛选</el-button>
                <el-button class="search-btn" @click="exportResult()">导出</el-button>
              </el-form-item>
              <div class="floatr">
                <el-form-item>
                  <el-button type="text" class="slide-btn" @click="toggleSlide('slideWrap1', $event)">展开筛选项</el-button>
                </el-form-item>
              </div>
            </div>
          </el-form>
        </el-tab-pane>
      </el-tabs>

      <div class="tableBody">
        <div class="title">
          筛选结果
        </div>
        <el-table class="limitManagerTable table-expand" style="width: 100%" :data="tableData" size="small" border
                  header-row-class-name="table-header">
          <el-table-column fixed="left" width="50" type="index" label="#" align="center"></el-table-column>
          <el-table-column width="200" prop="posStoreCode" label="岗位编码" align="center"></el-table-column>
          <el-table-column width="200" prop="posName" label="岗位名称" align="center"></el-table-column>
          <el-table-column width="200" prop="salary" label="岗位薪水" align="center"></el-table-column>
          <el-table-column width="180" prop="projectCode" label="项目编号" align="center"></el-table-column>
          <el-table-column width="200" prop="projectName" label="项目名称" align="center"></el-table-column>
          <el-table-column width="120" prop="province" label="省" align="center"></el-table-column>
          <el-table-column width="120" prop="city" label="市" align="center"></el-table-column>
          <el-table-column width="100" prop="channel" label="终端" align="center"></el-table-column>
          <el-table-column width="160" prop="system" label="系统" align="center"></el-table-column>
          <el-table-column width="200" prop="storeCode" label="门店编码" align="center"></el-table-column>
          <el-table-column width="200" prop="storeName" label="门店名称" align="center"></el-table-column>
          <el-table-column width="200" prop="scheduleNum" label="卖进序号" align="center"></el-table-column>
          <el-table-column width="220" prop="address" label="门店地址" align="center"></el-table-column>
          <el-table-column width="110" prop="publishUserName" label="发布人" align="center"></el-table-column>
          <el-table-column width="130" prop="publishTime" label="发布时间" align="center"></el-table-column>
          <el-table-column width="130" prop="requirementsStart" label="开始时间" align="center"></el-table-column>
          <el-table-column width="130" prop="requirementsEnd" label="结束时间" align="center"></el-table-column>
          <el-table-column width="100" prop="planNumber" label="计划人数" align="center"></el-table-column>
          <el-table-column width="100" prop="recruitsNumber" label="招聘人数" align="center"></el-table-column>
          <el-table-column width="100" prop="interviewNumber" label="面试人数" align="center"
                           :formatter="formatNum"></el-table-column>
          <el-table-column width="100" prop="interviewPassNumber" label="通过人数" align="center"
                           :formatter="formatNum"></el-table-column>
          <el-table-column width="100" prop="waitNumber" label="待审核人数" align="center"
                           :formatter="formatNum"></el-table-column>
          <el-table-column width="100" prop="requirementsStatus" label="岗位状态" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.requirementsStatus == 1">招聘中</div>
              <div v-if="scope.row.requirementsStatus == 2">已完成</div>
              <div v-if="scope.row.requirementsStatus == 3">已结束</div>
              <div v-if="scope.row.requirementsStatus == 4">已关闭</div>
              <div v-if="scope.row.requirementsStatus == 5">卖进关闭</div>
            </template>
          </el-table-column>
          <!-- <el-table-column width="160" prop="recruitsnum" label="开关招聘" align="center">
            <template slot-scope="scope">
              <el-switch v-if="scope.row.requirementsStatus != 3" v-model="scope.row.choose" @change="changeZhuangTai(scope.row)"></el-switch>
              <el-switch v-if="scope.row.requirementsStatus == 3" v-model="scope.row.choose" disabled></el-switch>
            </template>
          </el-table-column> -->
          <el-table-column fixed="right" label="操作" width="260" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" :disabled="scope.row.requirementsStatus == 3"
                         @click="edit(scope.row)">编辑
              </el-button>
              <span class="cutLine"></span>
              <el-button type="text" size="small" :disabled="scope.row.requirementsStatus == 3"
                         @click="handleApplyy(scope.row)">处理应聘
              </el-button>
              <!-- <span class="cutLine"></span>
              <el-button type="text" size="small" :disabled="scope.row.requirementsStatus == 2 || scope.row.requirementsStatus == 3">分享</el-button> -->
              <span v-if="closePosStoreFLag" class="cutLine"></span>
              <el-button v-if="closePosStoreFLag" type="text" size="small" :disabled="scope.row.requirementsStatus == 4 || scope.row.requirementsStatus == 5"
                         @click="confirmClosePosStore(scope.row.posStoreId)">关闭岗位
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination class="pagination table-pagination" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange" :current-page="formData.pageNo"
                       :page-sizes="[10, 20, 30, 40]" :page-size="formData.pageSize"
                       layout="slot,sizes, total,  prev, pager, next, jumper" :total="formData.total">
        </el-pagination>
      </div>
    </div>

    <el-dialog title="处理应聘" class="quitDialog dialog" width="1000px" :center="true" :show-close="true"
               :visible.sync="jobEdit">
      <HandleApply :Child="clickThis" @fresh="reFresh" @upup="changeHandle" :msg="msg" v-if="jobEdit"/>
    </el-dialog>

    <el-dialog title="编辑岗位" class="quitDialog dialog" width="1020px" :center="true" :show-close="false"
               :visible.sync="postEdit">
      <PostEdit :Child="clickThis" @upupup="changeEdit" :msg="msg1" @submitForm="submitForm()" v-if="postEdit"/>
    </el-dialog>

  </div>

</template>

<script>
  import utils from '../../common/js/util.js'
  import HandleApply from "./handleApply";
  import PostEdit from "./postEdit";

  export default {
    components: {HandleApply, PostEdit},
    watch: {
      bet: {
        tableData(newValue, oldValue) {
          console.log(newValue)
        },
        deep: true
      }
    },
    data() {
      return {
        //筛选项参数
        param: {
          posName: null,//岗位名称
          proCode: null, //项目编号
          proName: null, //项目名称
          storeName: null,
          storeCode: null, //门店编码
          province: null,
          city: null,
          terminal: null, //终端
          post: null, //岗位状态
          apply: null,
          postMan: null,//发布人
          salesmanName: null,//促销员姓名
          salesmanIdCard: null,//促销员身份证
          provinceId: null, //省级id
          cityId: null, //区级id
          publishTimeStart: null, // 发布日期
          publishTimeEnd: null,
          code: null, // 岗位编码
          scheduleNum: null
        },
        //表单翻页
        formData: {
          storeCode: null,
          storeName: null,
          pageNo: 1,
          pageSize: 10,
          total: null
        },
        provinceList: [], //省级数组
        cityList: [], //区级数组
        terminalList: [],//终端下拉列表
        terminals: [],//终端自动填充必须
        choosePost: [
          {name: '不限', id: 0},
          {name: "招聘中", id: 1},
          {name: "已完成", id: 2},
          {name: "已结束", id: 3},
          {name: "已关闭", id: 4},
          {name: "卖进关闭", id: 5}
        ], //选择岗位
        chooseApply: [
          {name: "不限", id: 0},
          {name: "待审核", id: 1},
          // {name: "已审核，待面试", id: 2},
          // {name: "审核不通过", id: 3},
          {name: "审核不通过", id: 5},
          {name: "审核通过", id: 6},
          {name: "释放", id: 4},
          // { name: "拒绝上岗", id: 7 },
          // { name: "离职", id: 8 },
          // { name: "三期", id: 9 },
          // { name: "工伤", id: 10 },
          // { name: "长期病假", id: 11 },
        ], //选择应聘状态
        //表单信息
        tableData: [],
        listLoading: false,
        jobEdit: false,//处理应聘
        postEdit: false,//编辑
        msg: false,//返回处理应聘信息
        msg1: false,//返回编辑信息
        clickThis: [],//把首页数据 传向处理应聘
        clickPosStoreId: '',
        showExport: false,
        closePosStoreFLag: false // 是否有关闭岗位权限
      };
    },
    mounted() {
      this.searchProvince();//搜索省
      this.searchCity();//搜索市
      this.getTerminal()//获取终端筛选列表
      this.resetForm();//清空并得到首页数据
      this.getPosStoreCloseFlag(); // 判断当前用户是否有关闭岗位权限
    },
    methods: {
      //工具类，错误提示框
      myNotify(_this, type, normal, or) {
        utils.myNotify(_this, type, normal, or)
      },
      formatNum(row, column, cellValue) {
        if (cellValue) {
          return cellValue
        } else {
          return '-'
        }
      },
      reFresh() {
        this.getData()
      },
      getData() {
        this.listLoading = true;
        let params = {
          posName: this.param.posName,//岗位名称
          projectCode: this.param.proCode, //项目编号
          projectName: this.param.proName, //项目名称
          storeName: this.param.storeName, //门店名称
          storeCode: this.param.storeCode, //门店编码
          province: this.param.province,
          city: this.param.city,
          channel: this.param.terminal != null ? this.param.terminal.replace(/(^\s*)|(\s*$)/g, "") : null, //终端
          requirementsStatus: this.param.post || null, //岗位状态
          auditStatus: this.param.apply, //应聘状态
          userName: this.param.postMan,//发布人
          salesmanName: this.param.salesmanName,//促销员姓名
          salesmanIdCard: this.param.salesmanIdCard,//促销员身份证
          empPk: this.param.empPk,//促销员empPk
          userId: sessionStorage.getItem('sysUserId'),
          publishTimeStart: this.param.publishTimeStart,
          publishTimeEnd: this.param.publishTimeEnd,
          code: this.param.code,
          pageSize: this.formData.pageSize,
          pageNo: this.formData.pageNo
        }
        //获取表单数据
        this.$http({
          method: "get",
          url: "/rest/PostManagement/searchUserProject",
          params
        }).then(res => {
          this.tableData = res.data.items;
          this.formData.total = res.data.totalItemsCount;
          this.listLoading = false;
        }).catch(err => {
          this.listLoading = false
          this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        });
      },
      //提交表单（筛选功能）
      submitForm() {
        //不限就是null的情况
        let pId = this.param.provinceId
        if (pId === null) {
          this.param.province = null
        } else {
          this.provinceList.map(item => {
            if (item.id == pId) {
              this.param.province = item.adName;
            }
          });
        }
        //city有343条，使用break优化，province才31条,map反而更快
        let cId = this.param.cityId
        let cList = this.cityList
        if (cId === null) {
          this.param.city = null
        } else {
          for (let i = 0; i < cList.length; i++) {
            if (cList[i].id == cId) {
              this.param.city = cList[i].adName;
              break;
            }
          }
        }
        //上面这俩遍历最多时候，共用时0.5ms
        this.formData.pageNo = 1;
        this.getData();
      },
      //重置表单（清除筛选项）
      resetForm() {
        this.param.posName = null;//岗位名称
        this.param.proCode = null; //项目编号
        this.param.proName = null; //项目名称
        this.param.storeName = null; //门店名称
        this.param.storeCode = null; //门店编码
        this.param.postMan = null;//发布人
        this.param.salesmanName = null;//促销员姓名
        this.param.salesmanIdCard = null;//促销员身份证
        this.param.province = null;//地区清空
        this.param.provinceId = null
        this.param.city = null;
        this.param.cityId = null;
        this.param.terminal = null; //终端
        this.param.post = null; //岗位状态
        this.param.apply = null; //应聘状态
        this.param.publishTimeStart = null;
        this.param.publishTimeEnd = null;
        this.param.code = null;
        this.getData();
      },
      //展开收起
      toggleSlide(slideWrap, event) {
        if (this.$refs[slideWrap].offsetHeight === 42) {
          this.$refs[slideWrap].style.height = "auto";
          event.target.innerHTML = "收起筛选项";
        } else {
          this.$refs[slideWrap].style.height = "42px";
          event.target.innerHTML = "展开筛选项";
        }
      },
      //搜索省市
      searchProvince(id) {
        this.$http({
          method: "POST",
          url: "/rest/salesman/getRegion",
          params: {
            deep: 1,
            regionId: id
          }
        }).then(res => {
          this.provinceList = res.data;
        }).catch(err => {
          this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
      searchCity(id) {
        this.param.cityId = null;
        this.$http({
          method: "POST",
          url: "/rest/salesman/getRegion",
          params: {
            deep: 2,
            regionId: id
          }
        }).then(res => {
          this.cityList = res.data;
        }).catch(err => {
          this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        });
      },

      // 终端下拉列表相关
      //获取终端下拉列表
      getTerminal() {
        this.param.terminal = null;
        this.$http({
          method: "GET",
          url: "/rest/PublishedWork/searchMasterName",
          params: {
            masterCode: 'CHANNEL'
          }
        }).then(res => {
          let arr = []
          res.data.map(item => {
            arr.push({value: String(item.masterName)})//
          })
          this.terminalList = arr
        }).catch(err => {
          this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        });
      },
      //自动填充方法
      querySearch(queryString, cb) {
        var results = queryString ? this.returnTerminal().filter(this.createFilter(queryString)) : this.returnTerminal();
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) != -1);
        };
      },
      returnTerminal() {
        return this.terminalList
      },

      //首页开关状态
      changeZhuangTai(value) {
        var flag = value.choose ? 1 : 2;
        this.$http({
          method: "POST",
          url: "/rest/PostManagement/updateRequirementsStatus",
          params: {
            posStoreId: value.posStoreId,
            requirementsStatus: flag
          }
        }).then(res => {
          this.getData();
        }).catch(err => {
          this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
          value.choose = !value.choose;
        });
      },
      //翻页
      handleSizeChange(value) {
        this.formData.pageSize = value;
        this.getData();
      },
      handleCurrentChange(value) {
        this.formData.pageNo = value;
        this.jobEdit = false

        this.getData();
      },
      //处理应聘
      changeHandle(msg) {
        console.log('处理应聘', msg)
        this.jobEdit = msg;
      },
      handleApplyy(item) {
        this.$http({
          method: "GET",
          url: "/rest/PostManagement/auditSalesmanPermission",
          params : {
            posStoreId: item.posStoreId
          }
        }).then(res => {
          if(res.data.code == '500') {
            this.$alert(res.data.message, '提示', {
              dangerouslyUseHTMLString: true,
            });
          }else {
            this.clickPosStoreId = item.posStoreId
            this.clickThis = [];
            this.clickThis.push(item);
            this.jobEdit = true;
          }
        }).catch(error => {

        });
      },
      //编辑
      edit(item) {
        this.clickThis = [];
        this.clickThis.push(item);
        this.postEdit = true;
      },
      changeEdit(msg1) {
        this.postEdit = msg1;
      },
      // 导出筛选结果
      exportResult() {
        let params = {
          posName: this.param.posName,//岗位名称
          projectCode: this.param.proCode, //项目编号
          projectName: this.param.proName, //项目名称
          storeName: this.param.storeName, //门店名称
          storeCode: this.param.storeCode, //门店编码
          province: this.param.province,
          city: this.param.city,
          channel: this.param.terminal != null ? this.param.terminal.replace(/(^\s*)|(\s*$)/g, "") : null, //终端
          requirementsStatus: this.param.post || null, //岗位状态
          auditStatus: this.param.apply, //应聘状态
          userName: this.param.postMan,//发布人
          salesmanName: this.param.salesmanName,//促销员姓名
          salesmanIdCard: this.param.salesmanIdCard,//促销员身份证
          userId: sessionStorage.getItem('sysUserId'),
          publishTimeStart: this.param.publishTimeStart,
          publishTimeEnd: this.param.publishTimeEnd,
          code: this.param.code,
          empPk: this.param.empPk,//促销员empPk
        };
        this.listLoading = true;
        this.$http({
          method: 'GET',
          url: '/rest/PostManagement/exportPosStore',
          params,
        }).then(res => {
          if(res.data && res.data.status == 200) {
            this.listLoading = false;
            location.href = utils.returnUrlHead() + res.data.data;
            // this.$alert(res.data.message);
          }else {
            this.listLoading = false;
            this.$alert(res.data.message);
          }
        }).catch(error => {
          this.listLoading = false;
          this.$alert("导出错误，请联系管理员！");
        });
      },
      // 查询是否有关闭岗位权限
      getPosStoreCloseFlag() {
        this.$http({
          method: 'GET',
          url: '/rest/role/canClosePos',
          params: {userId: sessionStorage.getItem('sysUserId')}
        }).then(res => {
          if (res.data.code == '0' && res.data.data == 1) {
            this.closePosStoreFLag = true;
          }
        }).catch(error => {
          console.log(error);
        });
      },
      // 确认关闭岗位
      confirmClosePosStore(posStoreId) {
        this.$confirm('确认关闭岗位？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.closePosStore(posStoreId)
        }).catch(() => {
        });
      },
      // 关闭岗位
      closePosStore(posStoreId) {
        this.$http({
          method: 'POST',
          url: '/rest/PublishedWork/closePosStore',
          data: {posStoreId: posStoreId, userId: sessionStorage.getItem("sysUserId")}
        }).then(res => {
          if(res.data.code == '0') {
            utils.myNotify(this, "success", res, '操作成功');
            this.getData();
          }else {
            utils.myNotify(this, "error", res, '操作失败');
          }
        }).catch(error => {
          console.log(error);
          this.getData();
        });
      }
    }
  };
</script>

<style scoped>
  .cutLine {
    border-right: 1px solid #82bc82;
    margin: 0 10px;
    position: relative;
    right: 1px;
  }

  .tableBody {
    background-color: white;
    margin-top: 15px;
    padding: 20px;
  }

  .title {
    color: #2e2b78;
    margin-bottom: 20px;
    font-weight: 900;
  }
  .el-button.is-disabled,.el-button.is-disabled:hover,.el-button.is-disabled:focus {
      background-color: white !important;
      color: rgba(130,188,130, 0.7);
      border: none;
  }
</style>



// WEBPACK FOOTER //
// src/views/workSquare/managementApply.vue